import React from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';
import { Calendar } from 'primereact/calendar';
import { InputTextarea } from 'primereact/inputtextarea';
import { AutoComplete } from 'primereact/autocomplete';
import acordLogo from 'images/acordlogo.png';
import CreateNewCarriers from '../CreateNewCarriers';
import AddNewSignature from '../AddNewSignature';
import { useSignatures } from '../../../../hooks/useSignatures';
import ProducerSection, { fetchPolicyAgentContact } from '../ProducerSection';
import { useCertificateHolders } from '../../../certificate-holders/hooks/useCertificateHolders';
import InsurerSearchDropdown from '../InsurerSearchDropdown';
import { formatUsPhone } from 'utilities/formatPhone';

const INSR_OPTIONS = ['A','B','C','D','E'].map(l => ({ label: l, value: l }));

interface Acord22FormProps { selectedPolicies?: string[]; insuredId?: string; }

export default function Acord22Form({ selectedPolicies = [], insuredId = '' }: Acord22FormProps) {
  const [showCreateCarrier, setShowCreateCarrier] = React.useState(false);
  const [showAddSignature, setShowAddSignature] = React.useState(false);
  const [producerAddress, setProducerAddress] = React.useState('');
  const [producerCity, setProducerCity] = React.useState('');
  const [producerState, setProducerState] = React.useState('');
  const [producerZip, setProducerZip] = React.useState('');
  const [producerStreet, setProducerStreet] = React.useState('');
  const [contactName, setContactName] = React.useState('');
  const [contactPhone, setContactPhone] = React.useState('');
  const [contactFax, setContactFax] = React.useState('');
  const [contactEmail, setContactEmail] = React.useState('');
  const [producerCustomerId, setProducerCustomerId] = React.useState('');
  const [insuredName, setInsuredName] = React.useState('');
  const [insuredAddress, setInsuredAddress] = React.useState('');
  const [insuredCity, setInsuredCity] = React.useState('');
  const [insuredState, setInsuredState] = React.useState('');
  const [insuredZip, setInsuredZip] = React.useState('');
  const [insurerA, setInsurerA] = React.useState('');
  const [insurerB, setInsurerB] = React.useState('');
  const [insurerC, setInsurerC] = React.useState('');
  const [insurerD, setInsurerD] = React.useState('');
  const [insurerE, setInsurerE] = React.useState('');
  const [certDate, setCertDate] = React.useState<Date | null>(new Date());
  const [cglCommercial, setCglCommercial] = React.useState(false);
  const [cglClaimsMade, setCglClaimsMade] = React.useState(false);
  const [cglOccur, setCglOccur] = React.useState(false);
  const [cglCustom1Check, setCglCustom1Check] = React.useState(false);
  const [cglCustom1Text, setCglCustom1Text] = React.useState('');
  const [cglCustom2Check, setCglCustom2Check] = React.useState(false);
  const [cglCustom2Text, setCglCustom2Text] = React.useState('');
  const [cglPolicy, setCglPolicy] = React.useState(false);
  const [cglCustomAggCheck, setCglCustomAggCheck] = React.useState(false);
  const [cglCustomAggText, setCglCustomAggText] = React.useState('');
  const [cglPolicyNumber, setCglPolicyNumber] = React.useState('');
  const [cglEffDate, setCglEffDate] = React.useState<Date | null>(null);
  const [cglExpDate, setCglExpDate] = React.useState<Date | null>(null);
  const [cglEachOccurrence, setCglEachOccurrence] = React.useState('');
  const [cglDamageRented, setCglDamageRented] = React.useState('');
  const [cglMedExp, setCglMedExp] = React.useState('');
  const [cglPersonalAdv, setCglPersonalAdv] = React.useState('');
  const [cglGeneralAgg, setCglGeneralAgg] = React.useState('');
  const [cglProductsAgg, setCglProductsAgg] = React.useState('');
  const [cglExtraLimitLabel, setCglExtraLimitLabel] = React.useState('');
  const [cglExtraLimitValue, setCglExtraLimitValue] = React.useState('');
  const [autoAnyAuto, setAutoAnyAuto] = React.useState(false);
  const [autoAllOwned, setAutoAllOwned] = React.useState(false);
  const [autoScheduled, setAutoScheduled] = React.useState(false);
  const [autoHired, setAutoHired] = React.useState(false);
  const [autoNonOwned, setAutoNonOwned] = React.useState(false);
  const [autoCustomCheck, setAutoCustomCheck] = React.useState(false);
  const [autoCustomText, setAutoCustomText] = React.useState('');
  const [autoPolicyNumber, setAutoPolicyNumber] = React.useState('');
  const [autoEffDate, setAutoEffDate] = React.useState<Date | null>(null);
  const [autoExpDate, setAutoExpDate] = React.useState<Date | null>(null);
  const [autoCombinedSingle, setAutoCombinedSingle] = React.useState('');
  const [autoBodilyPerson, setAutoBodilyPerson] = React.useState('');
  const [autoBodilyAccident, setAutoBodilyAccident] = React.useState('');
  const [autoPropertyDamage, setAutoPropertyDamage] = React.useState('');
  const [umbrellaLiab, setUmbrellaLiab] = React.useState(false);
  const [umbrellaOccur, setUmbrellaOccur] = React.useState(false);
  const [excessLiab, setExcessLiab] = React.useState(false);
  const [umbrellaClaimsMade, setUmbrellaClaimsMade] = React.useState(false);
  const [umbrellaDed, setUmbrellaDed] = React.useState(false);
  const [umbrellaRetention, setUmbrellaRetention] = React.useState(false);
  const [umbrellaRetentionAmt, setUmbrellaRetentionAmt] = React.useState('');
  const [umbrellaPolicyNumber, setUmbrellaPolicyNumber] = React.useState('');
  const [umbrellaEffDate, setUmbrellaEffDate] = React.useState<Date | null>(null);
  const [umbrellaExpDate, setUmbrellaExpDate] = React.useState<Date | null>(null);
  const [umbrellaEachOcc, setUmbrellaEachOcc] = React.useState('');
  const [umbrellaAggregate, setUmbrellaAggregate] = React.useState('');
  const [wcPolicyNumber, setWcPolicyNumber] = React.useState('');
  const [wcEffDate, setWcEffDate] = React.useState<Date | null>(null);
  const [wcExpDate, setWcExpDate] = React.useState<Date | null>(null);
  const [wcPerStatute, setWcPerStatute] = React.useState(false);
  const [wcOther, setWcOther] = React.useState(false);
  const [wcEachAccident, setWcEachAccident] = React.useState('');
  const [wcDiseaseEmployee, setWcDiseaseEmployee] = React.useState('');
  const [wcDiseasePolicyLimit, setWcDiseasePolicyLimit] = React.useState('');
  const [wcSpecialProvisions, setWcSpecialProvisions] = React.useState('');
  const [otherType, setOtherType] = React.useState('');
  const [otherPolicyNumber, setOtherPolicyNumber] = React.useState('');
  const [otherEffDate, setOtherEffDate] = React.useState<Date | null>(null);
  const [otherExpDate, setOtherExpDate] = React.useState<Date | null>(null);
  const [otherLimits, setOtherLimits] = React.useState('');
  const [descCheckbox, setDescCheckbox] = React.useState(false);
  const [descriptionOfOps, setDescriptionOfOps] = React.useState('');
  const [holderText, setHolderText] = React.useState('');
  const [holderSearchQuery, setHolderSearchQuery] = React.useState('');
  const { holders: holderSuggestions } = useCertificateHolders(holderSearchQuery, 10);

  const [authRepSignature, setAuthRepSignature] = React.useState('');
  const { signatureOptions, refetchSignatures } = useSignatures();
  const [signaturePreviewUrl, setSignaturePreviewUrl] = React.useState('');
  React.useEffect(() => {
    if (!authRepSignature) { setSignaturePreviewUrl(''); return; }
    fetch(`${process.env.REACT_APP_COIPortal_Url}/api/igigcoi/signature-preview/${authRepSignature}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('igtoken') || ''}`,
        'Content-Type': 'application/json',
        NCToken: localStorage.getItem('NCToken') || '',
      },
    })
      .then(r => r.ok ? r.text() : Promise.reject())
      .then(url => setSignaturePreviewUrl(url.replace(/^"|"$/g, '')))
      .catch(() => setSignaturePreviewUrl(''));
  }, [authRepSignature]);

  React.useEffect(() => {
    if (!selectedPolicies || selectedPolicies.length === 0) return;
    let cancelled = false;
    const fetchCoverages = async () => {
      try {
        const ncToken = localStorage.getItem('NCToken') || '';
        const igToken = localStorage.getItem('igtoken') || '';
        const res = await fetch(
          `${process.env.REACT_APP_COIPortal_Url}/api/IGIGCOI/get-coverages`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'NCToken': ncToken,
              Authorization: `Bearer ${igToken}`,
            },
            body: JSON.stringify({
              policiesIds: selectedPolicies,
              truckingCompanyId: insuredId || '',
              fileParentId: '3DFECA14-92AB-4F0E-879F-C1F669FD69DC',
              naics: [{ Code: '', Name: '' }],
              Page: 'certificateFiller',
            }),
          }
        );
        if (cancelled) return;
        await res.json();
      } catch {
        // silently fail — user can still fill manually
      }
    };
    fetchCoverages();
    return () => { cancelled = true; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPolicies, insuredId]);

  // Prefill contact section from the first selected policy's agent
  React.useEffect(() => {
    if (!selectedPolicies || selectedPolicies.length === 0) return;
    fetchPolicyAgentContact(selectedPolicies[0]).then(({ name, phone, fax, email }) => {
      if (name) setContactName(name);
      if (phone) setContactPhone(phone);
      if (fax) setContactFax(fax);
      if (email) setContactEmail(email);
    });
  }, [selectedPolicies]);

  return (
    <>
      <div className="masterCert__section">
        {/* ACORD HEADER */}
        <div className="masterCert__acordHeader">
          <img src={acordLogo} alt="ACORD" className="masterCert__acordLogo" />
          <div className="masterCert__acordTitleWrapper">
            <div className="masterCert__acordTitle">INTERMODAL INTERCHANGE CERTIFICATE OF INSURANCE</div>
          </div>
          <div className="masterCert__dateWrapper">
            <div className="masterCert__dateLabel">DATE (MM/DD/YYYY)</div>
            <div className="masterCert__dateCell">
              <Calendar value={certDate} onChange={(e) => setCertDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
            </div>
          </div>
        </div>

        {/* DISCLAIMER */}
        <div className="masterCert__disclaimer">
          This certificate is issued as a matter of information only and confers no rights upon the certificate holder. This certificate does not affirmatively or negatively amend, extend or alter the coverage afforded by the policies below. This certificate of insurance does not constitute a contract between the issuing insurer(s), authorized representative or producer, and the certificate holder.
        </div>

        {/* PRODUCER & CONTACT / INSURED & INSURERS */}
        <div className="masterCert__twoColumnLayout">
          {/* LEFT COLUMN */}
          <div>
            {/* PRODUCER */}
            <ProducerSection
              address={producerAddress}
              onAddressChange={setProducerAddress}
              city={producerCity}
              onCityChange={setProducerCity}
              street={producerStreet}
              onStreetChange={setProducerStreet}
              state={producerState}
              onStateChange={setProducerState}
              zip={producerZip}
              onZipChange={setProducerZip}
              onAgentContact={(phone, fax, email) => { setContactPhone(phone); setContactFax(fax); setContactEmail(email); }}
              readOnly
            />

            {/* INSURED */}
            <div>
              <div className="masterCert__sectionHeader">INSURED</div>
              <Dropdown value={insuredName} onChange={(e) => setInsuredName(e.value)} options={[]} placeholder="Type and/or choose location" className="masterCert__input masterCert__inputFull masterCert__inputMbSm" editable disabled emptyMessage="No available options" />
              <InputText maxLength={100} value={insuredAddress} onChange={(e) => setInsuredAddress(e.target.value)} placeholder="Address" className="masterCert__input masterCert__inputFull masterCert__inputMbSm" readOnly />
              <div className="masterCert__addressGrid">
                <InputText maxLength={100} value={insuredCity} onChange={(e) => setInsuredCity(e.target.value)} placeholder="City" className="masterCert__input masterCert__inputFull" readOnly />
                <InputText maxLength={50} value={insuredState} onChange={(e) => setInsuredState(e.target.value)} placeholder="State" className="masterCert__input masterCert__inputFull" readOnly />
                <InputText maxLength={20} value={insuredZip} onChange={(e) => setInsuredZip(e.target.value)} placeholder="Zip" className="masterCert__input masterCert__inputFull" readOnly />
              </div>
            </div>
          </div>

          {/* RIGHT COLUMN */}
          <div>
            {/* CONTACT INFO */}
            <div style={{ marginBottom: 16 }}>
              <div className="masterCert__contactGrid">
                <div>
                  <div className="masterCert__contactLabel">CONTACT NAME:</div>
                  <InputText maxLength={100} value={contactName} onChange={(e) => setContactName(e.target.value)} className="masterCert__input masterCert__inputFull" readOnly />
                </div>
                <div></div>
              </div>
              <div className="masterCert__contactGrid">
                <div>
                  <div className="masterCert__contactLabel">PHONE (A/C, No, Ext):</div>
                  <InputText value={formatUsPhone(contactPhone)} onChange={(e) => setContactPhone(e.target.value)} className="masterCert__input masterCert__inputFull" readOnly />
                </div>
                <div>
                  <div className="masterCert__contactLabel">FAX (A/C, No):</div>
                  <InputText value={formatUsPhone(contactFax)} onChange={(e) => setContactFax(e.target.value)} className="masterCert__input masterCert__inputFull" readOnly />
                </div>
              </div>
              <div>
                <div className="masterCert__contactLabel">E-MAIL ADDRESS:</div>
                <InputText maxLength={100} value={contactEmail} onChange={(e) => setContactEmail(e.target.value)} className="masterCert__input masterCert__inputFull" readOnly />
              </div>
              <div style={{ marginTop: 6 }}>
                <div className="masterCert__contactLabel">PRODUCER CUSTOMER ID #:</div>
                <InputText maxLength={30} value={producerCustomerId} onChange={(e) => setProducerCustomerId(e.target.value)} className="masterCert__input masterCert__inputFull" />
              </div>
            </div>

            {/* INSURERS AFFORDING COVERAGE */}
            <div>
              <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 8, marginBottom: 8 }}>
                <div className="masterCert__sectionHeader" style={{ marginBottom: 0 }}>INSURERS AFFORDING COVERAGE (and NAIC #)</div>
                <Button className="carrierDialog__secondaryBtn" label="Add New" icon="pi pi-plus" outlined size="small" style={{ flexShrink: 0, padding: '2px 10px', fontSize: '0.7rem', height: '28px' }} onClick={() => setShowCreateCarrier(true)} />
              </div>
              <div className="masterCert__insurersGrid">
                <div className="masterCert__insurerLabel">INSURER A</div>
                <InsurerSearchDropdown value={insurerA} onChange={setInsurerA} className="masterCert__input masterCert__inputFull" />
                <div className="masterCert__insurerLabel">INSURER B</div>
                <InsurerSearchDropdown value={insurerB} onChange={setInsurerB} className="masterCert__input masterCert__inputFull" />
                <div className="masterCert__insurerLabel">INSURER C</div>
                <InsurerSearchDropdown value={insurerC} onChange={setInsurerC} className="masterCert__input masterCert__inputFull" />
                <div className="masterCert__insurerLabel">INSURER D</div>
                <InsurerSearchDropdown value={insurerD} onChange={setInsurerD} className="masterCert__input masterCert__inputFull" />
                <div className="masterCert__insurerLabel">INSURER E</div>
                <InsurerSearchDropdown value={insurerE} onChange={setInsurerE} className="masterCert__input masterCert__inputFull" />
              </div>
            </div>
          </div>
        </div>

        {/* ═══ COVERAGES ═══ */}
        <div className="masterCert__coveragesSection">
          <div className="masterCert__coveragesTitle">COVERAGES</div>

          <div className="masterCert__disclaimer" style={{ marginBottom: 12 }}>
            The policies of insurance listed below have been issued to the insured named above for the policy period indicated. Notwithstanding any requirement, term or condition of any contract or other document with respect to which this certificate may be issued or may pertain, the insurance afforded by the policies described herein is subject to all the terms, exclusions and conditions of such policies. Aggregate limits shown may have been reduced by paid claims.
          </div>

          {/* Coverage Table Header */}
          <div className="masterCert__coverageHeader">
            <div>INSR<br/>LTR</div>
            <div>TYPE OF INSURANCE</div>
            <div>POLICY NUMBER</div>
            <div className="masterCert__coverageHeaderCenter">POLICY EFFECTIVE<br/>DATE (MM/DD/YY)</div>
            <div className="masterCert__coverageHeaderCenter">POLICY EXPIRATION<br/>DATE (MM/DD/YY)</div>
            <div>LIMITS</div>
          </div>

          {/* ── GENERAL LIABILITY ── */}
          <div className="masterCert__coverageRow">
            <div className="masterCert__coverageInsr">
              <Dropdown options={INSR_OPTIONS} placeholder="" className="masterCert__input" emptyMessage="No available options" />
            </div>
            <div>
              <div className="masterCert__coverageType">GENERAL LIABILITY</div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="a22CglCommercial" checked={cglCommercial} onChange={(e) => setCglCommercial(e.checked ?? false)} />
                <label htmlFor="a22CglCommercial" className="masterCert__checkboxItemLabel">COMMERCIAL GENERAL LIABILITY</label>
              </div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="a22CglClaimsMade" checked={cglClaimsMade} onChange={(e) => setCglClaimsMade(e.checked ?? false)} />
                <label htmlFor="a22CglClaimsMade" className="masterCert__checkboxItemLabel">CLAIMS MADE</label>
              </div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="a22CglOccur" checked={cglOccur} onChange={(e) => setCglOccur(e.checked ?? false)} />
                <label htmlFor="a22CglOccur" className="masterCert__checkboxItemLabel">OCCUR</label>
              </div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="a22CglCustom1" checked={cglCustom1Check} onChange={(e) => setCglCustom1Check(e.checked ?? false)} />
                <InputText value={cglCustom1Text} onChange={(e) => setCglCustom1Text(e.target.value)} className="masterCert__input masterCert__inputXs" />
              </div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="a22CglCustom2" checked={cglCustom2Check} onChange={(e) => setCglCustom2Check(e.checked ?? false)} />
                <InputText value={cglCustom2Text} onChange={(e) => setCglCustom2Text(e.target.value)} className="masterCert__input masterCert__inputXs" />
              </div>
              <div className="masterCert__coverageTypeAlt">GEN'L AGGREGATE LIMIT APPLIES PER:</div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="a22CglPolicy" checked={cglPolicy} onChange={(e) => setCglPolicy(e.checked ?? false)} />
                <label htmlFor="a22CglPolicy" className="masterCert__checkboxItemLabel">POLICY</label>
              </div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="a22CglCustomAgg" checked={cglCustomAggCheck} onChange={(e) => setCglCustomAggCheck(e.checked ?? false)} />
                <InputText value={cglCustomAggText} onChange={(e) => setCglCustomAggText(e.target.value)} className="masterCert__input masterCert__inputXs" />
              </div>
            </div>
            <InputText maxLength={50} value={cglPolicyNumber} onChange={(e) => setCglPolicyNumber(e.target.value)} className="masterCert__input masterCert__inputFull" />
            <div className="masterCert__dateCell">
              <Calendar value={cglEffDate} onChange={(e) => setCglEffDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
            </div>
            <div className="masterCert__dateCell">
              <Calendar value={cglExpDate} onChange={(e) => setCglExpDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
            </div>
            <div className="masterCert__limitsGrid">
              <div className="masterCert__limitLabel">EACH OCCURRENCE</div>
              <InputText value={cglEachOccurrence} onChange={(e) => setCglEachOccurrence(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
              <div className="masterCert__limitLabel">DAMAGE TO RENTED<br/>PREMISES (Ea occurence)</div>
              <InputText value={cglDamageRented} onChange={(e) => setCglDamageRented(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
              <div className="masterCert__limitLabel">MED EXP (Any one person)</div>
              <InputText value={cglMedExp} onChange={(e) => setCglMedExp(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
              <div className="masterCert__limitLabel">PERSONAL &amp; ADV INJURY</div>
              <InputText value={cglPersonalAdv} onChange={(e) => setCglPersonalAdv(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
              <div className="masterCert__limitLabel">GENERAL AGGREGATE</div>
              <InputText value={cglGeneralAgg} onChange={(e) => setCglGeneralAgg(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
              <div className="masterCert__limitLabel">PRODUCTS-COMP/OP AGG</div>
              <InputText value={cglProductsAgg} onChange={(e) => setCglProductsAgg(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
              <InputText value={cglExtraLimitLabel} onChange={(e) => setCglExtraLimitLabel(e.target.value)} className="masterCert__input masterCert__limitInput" />
              <InputText value={cglExtraLimitValue} onChange={(e) => setCglExtraLimitValue(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
            </div>
          </div>

          {/* ── AUTOMOBILE LIABILITY ── */}
          <div className="masterCert__coverageRow">
            <div className="masterCert__coverageInsr">
              <Dropdown options={INSR_OPTIONS} placeholder="" className="masterCert__input" emptyMessage="No available options" />
            </div>
            <div>
              <div className="masterCert__coverageType">AUTOMOBILE LIABILITY</div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="a22AutoAnyAuto" checked={autoAnyAuto} onChange={(e) => setAutoAnyAuto(e.checked ?? false)} />
                <label htmlFor="a22AutoAnyAuto" className="masterCert__checkboxItemLabel">ANY AUTO</label>
              </div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="a22AutoAllOwned" checked={autoAllOwned} onChange={(e) => setAutoAllOwned(e.checked ?? false)} />
                <label htmlFor="a22AutoAllOwned" className="masterCert__checkboxItemLabel">ALL OWNED AUTOS</label>
              </div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="a22AutoScheduled" checked={autoScheduled} onChange={(e) => setAutoScheduled(e.checked ?? false)} />
                <label htmlFor="a22AutoScheduled" className="masterCert__checkboxItemLabel">SCHEDULED AUTOS</label>
              </div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="a22AutoHired" checked={autoHired} onChange={(e) => setAutoHired(e.checked ?? false)} />
                <label htmlFor="a22AutoHired" className="masterCert__checkboxItemLabel">HIRED AUTOS</label>
              </div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="a22AutoNonOwned" checked={autoNonOwned} onChange={(e) => setAutoNonOwned(e.checked ?? false)} />
                <label htmlFor="a22AutoNonOwned" className="masterCert__checkboxItemLabel">NON-OWNED AUTOS</label>
              </div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="a22AutoCustom" checked={autoCustomCheck} onChange={(e) => setAutoCustomCheck(e.checked ?? false)} />
                <InputText value={autoCustomText} onChange={(e) => setAutoCustomText(e.target.value)} className="masterCert__input masterCert__inputXs" />
              </div>
            </div>
            <InputText maxLength={50} value={autoPolicyNumber} onChange={(e) => setAutoPolicyNumber(e.target.value)} className="masterCert__input masterCert__inputFull" />
            <div className="masterCert__dateCell">
              <Calendar value={autoEffDate} onChange={(e) => setAutoEffDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
            </div>
            <div className="masterCert__dateCell">
              <Calendar value={autoExpDate} onChange={(e) => setAutoExpDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
            </div>
            <div className="masterCert__limitsGrid">
              <div className="masterCert__limitLabel">COMBINED SINGLE LIMIT<br/>(Ea accident)</div>
              <InputText value={autoCombinedSingle} onChange={(e) => setAutoCombinedSingle(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
              <div className="masterCert__limitLabel">BODILY INJURY (Per person)</div>
              <InputText value={autoBodilyPerson} onChange={(e) => setAutoBodilyPerson(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
              <div className="masterCert__limitLabel">BODILY INJURY (Per accident)</div>
              <InputText value={autoBodilyAccident} onChange={(e) => setAutoBodilyAccident(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
              <div className="masterCert__limitLabel">PROPERTY DAMAGE (Per<br/>accident)</div>
              <InputText value={autoPropertyDamage} onChange={(e) => setAutoPropertyDamage(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
            </div>
          </div>

          {/* ── UMBRELLA / EXCESS LIABILITY ── */}
          <div className="masterCert__coverageRow">
            <div className="masterCert__coverageInsr">
              <Dropdown options={INSR_OPTIONS} placeholder="" className="masterCert__input" emptyMessage="No available options" />
            </div>
            <div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="a22UmbrellaLiab" checked={umbrellaLiab} onChange={(e) => setUmbrellaLiab(e.checked ?? false)} />
                <label htmlFor="a22UmbrellaLiab" className="masterCert__coverageType" style={{ marginLeft: 4 }}>UMBRELLA LIAB</label>
              </div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="a22UmbrellaOccur" checked={umbrellaOccur} onChange={(e) => setUmbrellaOccur(e.checked ?? false)} />
                <label htmlFor="a22UmbrellaOccur" className="masterCert__checkboxItemLabel">OCCUR</label>
              </div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="a22ExcessLiab" checked={excessLiab} onChange={(e) => setExcessLiab(e.checked ?? false)} />
                <label htmlFor="a22ExcessLiab" className="masterCert__coverageType" style={{ marginLeft: 4 }}>EXCESS LIAB</label>
              </div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="a22UmbrellaClaimsMade" checked={umbrellaClaimsMade} onChange={(e) => setUmbrellaClaimsMade(e.checked ?? false)} />
                <label htmlFor="a22UmbrellaClaimsMade" className="masterCert__checkboxItemLabel">CLAIMS MADE</label>
              </div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="a22UmbrellaDed" checked={umbrellaDed} onChange={(e) => setUmbrellaDed(e.checked ?? false)} />
                <label htmlFor="a22UmbrellaDed" className="masterCert__checkboxItemLabel">DED</label>
              </div>
              <div className="masterCert__checkboxItem">
                <Checkbox inputId="a22UmbrellaRetention" checked={umbrellaRetention} onChange={(e) => setUmbrellaRetention(e.checked ?? false)} />
                <label className="masterCert__checkboxItemLabel">RETENTION $</label>
                <InputText value={umbrellaRetentionAmt} onChange={(e) => setUmbrellaRetentionAmt(e.target.value)} className="masterCert__input masterCert__inputXs" />
              </div>
            </div>
            <InputText maxLength={50} value={umbrellaPolicyNumber} onChange={(e) => setUmbrellaPolicyNumber(e.target.value)} className="masterCert__input masterCert__inputFull" />
            <div className="masterCert__dateCell">
              <Calendar value={umbrellaEffDate} onChange={(e) => setUmbrellaEffDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
            </div>
            <div className="masterCert__dateCell">
              <Calendar value={umbrellaExpDate} onChange={(e) => setUmbrellaExpDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
            </div>
            <div className="masterCert__limitsGrid">
              <div className="masterCert__limitLabel">EACH OCCURRENCE</div>
              <InputText value={umbrellaEachOcc} onChange={(e) => setUmbrellaEachOcc(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
              <div className="masterCert__limitLabel">AGGREGATE</div>
              <InputText value={umbrellaAggregate} onChange={(e) => setUmbrellaAggregate(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
            </div>
          </div>

          {/* ── WORKERS COMPENSATION ── */}
          <div className="masterCert__coverageRow">
            <div className="masterCert__coverageInsr">
              <Dropdown options={INSR_OPTIONS} placeholder="" className="masterCert__input" emptyMessage="No available options" />
            </div>
            <div>
              <div className="masterCert__coverageType">WORKERS COMPENSATION AND EMPLOYERS' LIABILITY</div>
              <div className="masterCert__wcNote">ANY PROPRIETOR / PARTNER / EXECUTIVE<br/>OFFICER / MEMBER EXCLUDED?</div>
              <div className="masterCert__wcNote">(Mandatory in NH)</div>
              <div className="masterCert__wcNote">If yes, describe under<br/>SPECIAL PROVISIONS below</div>
              <InputText maxLength={2000} value={wcSpecialProvisions} onChange={(e) => setWcSpecialProvisions(e.target.value)} className="masterCert__input masterCert__inputFull" />
            </div>
            <InputText maxLength={50} value={wcPolicyNumber} onChange={(e) => setWcPolicyNumber(e.target.value)} className="masterCert__input masterCert__inputFull" />
            <div className="masterCert__dateCell">
              <Calendar value={wcEffDate} onChange={(e) => setWcEffDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
            </div>
            <div className="masterCert__dateCell">
              <Calendar value={wcExpDate} onChange={(e) => setWcExpDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
            </div>
            <div className="masterCert__limitsGrid">
              <div className="masterCert__wcStatutory">
                <Checkbox inputId="a22WcPerStatute" checked={wcPerStatute} onChange={(e) => setWcPerStatute(e.checked ?? false)} />
                <label htmlFor="a22WcPerStatute" className="masterCert__checkboxItemLabel">PER STATUTE</label>
              </div>
              <InputText className="masterCert__input masterCert__limitInput" />
              <div className="masterCert__wcStatutory">
                <Checkbox inputId="a22WcOther" checked={wcOther} onChange={(e) => setWcOther(e.checked ?? false)} />
                <label htmlFor="a22WcOther" className="masterCert__checkboxItemLabel">OTHER</label>
              </div>
              <InputText className="masterCert__input masterCert__limitInput" />
              <div className="masterCert__limitLabel">E.L. EACH ACCIDENT</div>
              <InputText value={wcEachAccident} onChange={(e) => setWcEachAccident(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
              <div className="masterCert__limitLabel">E.L. DISEASE - EA EMPLOYEE</div>
              <InputText value={wcDiseaseEmployee} onChange={(e) => setWcDiseaseEmployee(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
              <div className="masterCert__limitLabel">E.L. DISEASE - POLICY LIMIT</div>
              <InputText value={wcDiseasePolicyLimit} onChange={(e) => setWcDiseasePolicyLimit(e.target.value)} placeholder="$" className="masterCert__input masterCert__limitInput" />
            </div>
          </div>

          {/* ── OTHER ── */}
          <div className="masterCert__coverageRow">
            <div className="masterCert__coverageInsr">
              <Dropdown options={INSR_OPTIONS} placeholder="" className="masterCert__input" emptyMessage="No available options" />
            </div>
            <div>
              <div className="masterCert__coverageType">OTHER</div>
              <InputText maxLength={100} value={otherType} onChange={(e) => setOtherType(e.target.value)} placeholder="Type of insurance" className="masterCert__input masterCert__inputFull" />
            </div>
            <InputText maxLength={50} value={otherPolicyNumber} onChange={(e) => setOtherPolicyNumber(e.target.value)} className="masterCert__input masterCert__inputFull" />
            <div className="masterCert__dateCell">
              <Calendar value={otherEffDate} onChange={(e) => setOtherEffDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
            </div>
            <div className="masterCert__dateCell">
              <Calendar value={otherExpDate} onChange={(e) => setOtherExpDate(e.value as Date)} className="masterCert__input" showIcon dateFormat="mm/dd/yy" />
            </div>
            <InputText value={otherLimits} onChange={(e) => setOtherLimits(e.target.value)} placeholder="Limits" className="masterCert__input masterCert__inputFull" />
          </div>
        </div>

        {/* DESCRIPTION OF OPERATIONS */}
        <div className="masterCert__descriptionSection">
          <div className="masterCert__descriptionTitle">
            DESCRIPTION OF OPERATIONS / VEHICLES / EXCLUSIONS ADDED BY ENDORSEMENT / SPECIAL PROVISIONS (Attach ACORD 101, Additional Remarks Schedule, if more space is required)
          </div>
          <div style={{ marginBottom: 8 }}>
            <Checkbox inputId="a22DescCheckbox" checked={descCheckbox} onChange={(e) => setDescCheckbox(e.checked ?? false)} />
          </div>
          <div className="masterCert__disclaimer" style={{ marginBottom: 8 }}>
            The Truckers Uniform Intermodal Interchange Endorsement (Form UIIE-1 or CA 23-17 equivalent) is part of the auto policy(ies). The attached list of providers are additional insureds in regards to the auto liability. Those providers with (*) are additional insureds on the general liability and those with (**) are additional insureds on trailer interchange coverage.
          </div>
          <InputTextarea maxLength={2000} value={descriptionOfOps} onChange={(e) => setDescriptionOfOps(e.target.value)} rows={4} className="masterCert__descriptionTextarea" />
        </div>

        {/* CERTIFICATE HOLDER & CANCELLATION */}
        <div className="masterCert__bottomRow">
          <div className="masterCert__certHolderBox">
            <div className="masterCert__sectionHeader">CERTIFICATE HOLDER</div>
            <div style={{ position: 'relative', width: '100%', marginBottom: 6 }}>
              <i className="pi pi-search" style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: '#6c757d', fontSize: 13, zIndex: 1, pointerEvents: 'none' }} />
              <AutoComplete
                value={holderSearchQuery}
                suggestions={holderSuggestions.map((h) => ({ label: h.name, value: h }))}
                completeMethod={(e) => setHolderSearchQuery(e.query)}
                onChange={(e) => { if (typeof e.value === 'string') setHolderSearchQuery(e.value); }}
                field="label"
                placeholder="Search for a certificate holder"
                style={{ width: '100%' }}
                inputStyle={{ width: '100%', paddingLeft: 30 }}
                disabled
                onSelect={(e) => {
                  const h = e.value.value;
                  const lines = [h.name, h.addressLine1, h.addressLine2, [h.city, h.stateName, h.zipCode].filter(Boolean).join(', ')].filter(Boolean);
                  setHolderText(lines.join('\n'));
                  setHolderSearchQuery('');
                }}
              />
            </div>
            <InputTextarea maxLength={2000} value={holderText} onChange={(e) => setHolderText(e.target.value)} rows={5} className="masterCert__descriptionTextarea" disabled />
          </div>
          <div className="masterCert__cancellationBox">
            <div className="masterCert__sectionHeader">CANCELLATION</div>
            <div className="masterCert__cancellationText">
              Should any of the above described policies be cancelled before the expiration date thereof, notice will be delivered in accordance with the policy provisions.
            </div>
            <div className="masterCert__authRepLabel">AUTHORIZED REPRESENTATIVE</div>
            <div className="masterCert__authRepRow">
              <Dropdown value={authRepSignature} onChange={(e) => setAuthRepSignature(e.value)} options={signatureOptions} optionLabel="label" optionValue="value" placeholder="Select signature:" className="masterCert__input masterCert__authRepDropdown" emptyMessage="No available options" />
              <Button label="Create New" className="p-button-outlined carrierDialog__secondaryBtn" onClick={() => setShowAddSignature(true)} />
            </div>
              {signaturePreviewUrl && (
                <div style={{ marginTop: 8 }}>
                  <img src={signaturePreviewUrl} alt="Signature preview" style={{ maxHeight: 60, maxWidth: 280, objectFit: 'contain', border: '1px solid #e5e7eb', borderRadius: 6, padding: '4px 8px', background: '#fff' }} />
                </div>
              )}
          </div>
        </div>

        {/* ACORD Footer */}
        <div className="masterCert__acordFooter">
          <div>ACORD 22 (2012/04)</div>
          <div>&copy; 2006-2012 ACORD CORPORATION. All rights reserved.</div>
        </div>
      </div>

      <CreateNewCarriers open={showCreateCarrier} onClose={() => setShowCreateCarrier(false)} />
      <AddNewSignature open={showAddSignature} onClose={() => setShowAddSignature(false)} onSaved={refetchSignatures} />
    </>
  );
}
